import { buffer, centroid } from '@turf/turf';
import { Geometry, Point, Polygon } from 'geojson';
import { LatLngLiteral } from 'leaflet';

export const includeColor = '#0c637b';

export const excludeColor = '#eb5a2c';

export const bilikZoneColor = '#000000';

export const bilikZoneFillColor = '#ffdd00';

export const isPoint = (geometry: Geometry): geometry is Point =>
  geometry.type === 'Point';

export const addCrs = (geometry?: Geometry) => {
  if (!geometry) {
    return undefined;
  }
  return {
    ...geometry,
    crs: { type: 'name', properties: { name: 'EPSG:4326' } },
  };
};

export const toGeometryGeoJSON = (
  latlng: LatLngLiteral,
  radius?: number,
): Geometry | undefined => {
  return buffer(
    {
      type: 'Point',
      coordinates: [latlng.lng, latlng.lat],
    },
    radius ?? 1,
  )?.geometry as Polygon;
};

export const getLatLngCenter = (geometry: Geometry): LatLngLiteral => {
  const center = centroid(geometry).geometry.coordinates;

  return {
    lng: center[0],
    lat: center[1],
  };
};
